import React from "react";
import { node, oneOf, string } from "prop-types";

import calloutCardThemes from "../../constants/calloutCardThemes";
import imagePositions from "../../constants/imagePositions";
import * as S from "../styled";

const HorizontalCalloutCardStatic = React.forwardRef(
  (
    {
      description,
      headline,
      illustration,
      imagePosition,
      theme,
      ...passThroughProps
    },
    ref
  ) => (
    <S.HorizontalCardWrapper ref={ref} theme={theme} {...passThroughProps}>
      {illustration && (
        <S.IllustrationWrapper imagePosition={imagePosition}>
          {illustration}
        </S.IllustrationWrapper>
      )}
      <S.ContentWrapper>
        <S.Headline>{headline}</S.Headline>
        {description && <S.Description>{description}</S.Description>}
      </S.ContentWrapper>
    </S.HorizontalCardWrapper>
  )
);

HorizontalCalloutCardStatic.propTypes = {
  /**
   * Adds a description block to the Callout Card
   */
  description: string,
  /**
   * Headline for the Callout Card
   */
  headline: string.isRequired,
  /**
   * A component that defines the illustration for the Callout Card.
   * Please use either:
   *   - Brand icon (Images and Icons/Icon/Brand) of size MD
   *   - Avatar of size SM
   */
  illustration: node,
  /**
   * If an illustration is provided, imagePosition will allow to justify it to the right.
   * It is one of:
   *   - LEFT (default)
   *   - RIGHT
   */
  imagePosition: oneOf([imagePositions.LEFT, imagePositions.RIGHT]),
  /**
   * The Callout Card theme. One of:
   *   - BLUE
   *   - ORANGE
   *   - GRAY
   *   - WHITE
   */
  theme: oneOf(Object.values(calloutCardThemes))
};

HorizontalCalloutCardStatic.defaultProps = {
  description: null,
  illustration: null,
  imagePosition: imagePositions.LEFT,
  theme: calloutCardThemes.WHITE
};

export default HorizontalCalloutCardStatic;
